import React, { useState } from "react";
import { api } from "../api/api";

export default function MailModal({ onClose }) {
  const [form, setForm]       = useState({ betreff: "", text: "" });
  const [success, setSuccess] = useState(false);
  const [error, setError]     = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await api.mail.sendAll(form);
      setSuccess(true);
    } catch {
      setError("Fehler beim Senden. SMTP noch nicht konfiguriert.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
    }}>
      <div style={{
        background: "white", borderRadius: "16px", padding: "2rem",
        width: "100%", maxWidth: "550px", boxShadow: "0 8px 32px rgba(0,0,0,0.2)"
      }}>
        <h3 style={{ color: "#2e7d32", marginBottom: "1.25rem" }}>📧 Rundmail an alle Kunden</h3>

        {success && <div className="alert alert-success">✓ Mail erfolgreich versendet!</div>}
        {error   && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Betreff *</label>
            <input value={form.betreff} required
              onChange={e => setForm({ ...form, betreff: e.target.value })}
              placeholder="z.B. Neue Angebote im Mai" />
          </div>
          <div className="form-group">
            <label>Nachricht *</label>
            <textarea rows={7} value={form.text} required
              onChange={e => setForm({ ...form, text: e.target.value })}
              placeholder="Schreib hier deine Nachricht an alle Kunden..." />
          </div>
          <div style={{ display: "flex", gap: "0.75rem", marginTop: "0.5rem" }}>
            <button className="btn btn-success" type="submit" disabled={loading} style={{ flex: 1 }}>
              {loading ? "Wird gesendet..." : "📨 An alle senden"}
            </button>
            <button type="button" onClick={onClose} className="btn btn-secondary">
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
